import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './js/public'
import 'swiper/swiper.min.css'
import VueCookies from 'vue-cookies'

// import $ from 'jquery'

// window.jQuery = $;
// window.$ = $;

createApp(App).use(ElementPlus).use(store).use(router).use(VueCookies).mount('#app')

